<template>
  <div class="participant-login-container">
    <div class="login-card">
      <div class="login-header">
        <h2>Participant Login</h2>
        <p>Access your voting dashboard</p>
      </div>

      <div class="login-form">


        <b-field label="Email">
          <b-input v-model="form.email" type="email" placeholder="Enter your email"
            @keyup.enter="handleLogin"></b-input>
        </b-field>

        <b-field label="Password">
          <b-input v-model="form.password" type="password" placeholder="Enter your password"
            @keyup.enter="handleLogin"></b-input>
        </b-field>

        <b-button type="is-primary" size="is-medium" :loading="loading" @click="handleLogin" expanded>
          Login
        </b-button>

        <div v-if="error" class="error-message">
          <b-message type="is-danger" size="is-small">
            {{ error }}
          </b-message>
        </div>
      </div>

      <div class="login-footer">
        <p>Don't have an account? Contact your voting organizer.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParticipantLogin',
  data() {
    return {
      form: {
        email: '',
        password: '',
        voting_session_id: null
      },
      loading: false,
      error: null
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.voting_session_id = this.$route.params.id
    }
  },
  methods: {
    async handleLogin() {
      let vm = this;
      if (!this.form.email || !this.form.password || !this.form.voting_session_id) {
        this.error = 'Please fill in all fields'
        return
      }

      this.loading = true
      this.error = null

      try {
        const response = await this.$store.dispatch('PARTICIPANT_LOGIN', this.form)

        if (response.data.status === 'ok') {
          localStorage.setItem('participant_data', JSON.stringify(response.data.data.participant))
          let user = {
            access_token: response.data.data.token,
            user: response.data.data.participant,
          };
          vm.$saveLoginInfo(user);
          // Redirect to dashboard
          this.$router.push('/participant/dashboard')
        } else {
          this.error = response.data.message || 'Login failed'
        }
      } catch (error) {
        console.error('Login error:', error)
        this.error = error.response.data.message || 'Login failed. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.participant-login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;

  .login-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    padding: 40px;
    width: 100%;
    max-width: 400px;

    .login-header {
      text-align: center;
      margin-bottom: 30px;

      h2 {
        color: #333;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 8px;
      }

      p {
        color: #666;
        font-size: 16px;
        margin: 0;
      }
    }

    .login-form {
      .field {
        margin-bottom: 20px;

        .label {
          color: #333;
          font-weight: 500;
          margin-bottom: 8px;
        }
      }

      .button {
        margin-top: 10px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        font-weight: 600;
        transition: transform 0.2s ease;

        &:hover {
          transform: translateY(-2px);
        }
      }
    }

    .login-footer {
      text-align: center;
      margin-top: 30px;
      padding-top: 20px;
      border-top: 1px solid #eee;

      p {
        color: #666;
        font-size: 14px;
        margin: 0;
      }
    }
  }

  .error-message {
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .participant-login-container {
    padding: 10px;

    .login-card {
      padding: 30px 20px;
    }
  }
}
</style>
